import AdminLayout from '../../components/AdminLayout';
import UserTable from '../../components/UserTable';
import Regsiter from './register';


const DashboardPage = () => {
    return (
        <AdminLayout>
            <Regsiter />
            <UserTable/>
        </AdminLayout>
    );
};

export default DashboardPage;